import { serviceMaker, methods, api } from "@/http/index.js";

export const getCurrencies = () =>
  serviceMaker(`/currencies/all?limit=0&offset=0`, methods.GET, api.NGB);
export const deleteCurrency = (id) =>
  serviceMaker(`/currencies/${id}`, methods.DELETE, api.NGB);
export const createCurrency = (data) =>
  serviceMaker(`/currencies`, methods.POST, api.NGB, data);
export const getCurrencyById = (id) =>
  serviceMaker(`/currencies/${id}`, methods.GET, api.NGB);
export const editCurrency = (id, data) =>
  serviceMaker(`/currencies/update/${id}`, methods.PUT, api.NGB, data);
export const getCurrencyView = (id) =>
  serviceMaker(`/currencies/${id}`, methods.GET, api.NGB);
